import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TalentosCollection from "../../components/conoce-talentos/TalentosCollection";
import { getQuizPhaseThunk } from "../../store/quiz/quiz.thunks";

const MisTalentosPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { phase } = useSelector((state) => state.quiz);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Obtener el estado actualizado del quiz
    const checkPhase = async () => {
      await dispatch(getQuizPhaseThunk());
      setIsChecking(false);
    };
    checkPhase();
  }, [dispatch]);

  useEffect(() => {
    // Proteger la ruta: solo accesible si el quiz está completado
    if (!isChecking && (phase === "en_progreso" || phase === "sin_iniciar")) {
      navigate("/#/home");
    }
  }, [phase, navigate, isChecking]);

  // Mostrar loading mientras se verifica el estado
  if (isChecking || phase !== "completada") {
    return null;
  }

  return <TalentosCollection />;
};

export default MisTalentosPage;
